import { createUseStyles } from 'react-jss'

const usePageStyles = createUseStyles({
  pageWrapper: {
    padding: '20px 35px',
    minWidth: 900,
    height: '100%'
  }
})

export { usePageStyles }
